import { PropsWithChildren, useState, useRef } from "react";
import { Box, Collapse, useTheme, useMediaQuery, SxProps, Theme } from "@mui/material";
import { IconCaret } from "src/components/icons-mui/caret";
import { Button } from "src/components-mui/base/button/button";
import { DETAILS_ACCORDION_SHOW_BUTTON_TEST_ID } from "src/components-mui/pages/detail/certificate-box/components/details-accordion.test-ids";
import { useCertificateBoxContext } from "src/components-mui/pages/detail/certificate-box/context";

interface ICBDetailsAccordionProps {
    buttonContainerSx?: SxProps<Theme>;
}

export const CBDetailsAccordion = ({ children, buttonContainerSx }: PropsWithChildren<ICBDetailsAccordionProps>): JSX.Element => {
    const { dict } = useCertificateBoxContext();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"), { defaultMatches: true });
    const [manualOpen, setManualOpen] = useState(false);
    const openedOnce = useRef(false);
    // Derive open state: always open on desktop, or after manual open
    const isOpen = isDesktop || manualOpen;

    // When toggled manually, open and mark as openedOnce (cannot close again)
    const handleToggle = () => {
        if (!openedOnce.current) {
            setManualOpen(true);
            openedOnce.current = true;
        }
    };

    const showButton = !isDesktop && !isOpen;
    return (
        <>
            {showButton && (
                <Box
                    sx={{
                        textAlign: "right",
                        ...buttonContainerSx,
                    }}
                >
                    <Button
                        size="small"
                        variant="text"
                        sx={{ pr: 0, mt: -2, mr: "-5px" }}
                        endIcon={<IconCaret sx={{ width: "24px", height: "24px" }} />}
                        onClick={handleToggle}
                        data-test-id={DETAILS_ACCORDION_SHOW_BUTTON_TEST_ID}
                    >
                        {dict.show}
                    </Button>
                </Box>
            )}
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                {children}
            </Collapse>
        </>
    );
};
